/* eslint-disable @typescript-eslint/no-unused-vars */
export const getkeywordSuggestionStyles = (_, { palette = {} }) => ({
  keywordSuggestionContainer: {
    marginTop: 24,
  },
});

const getKeywordSuggestionFooterButtonStyle = (_, { palette }) => ({
  rootHovered: {
    color: palette.white,
    backgroundColor: palette.themePrimary,
  },
  rootDisabled: {
    backgroundColor: palette.neutralLighter,
    color: palette.neutralTertiary,
  },
  textContainer: {
    overflow: 'hidden',
  },
  iconDisabled: {
    color: palette.neutralTertiaryAlt,
  },
  iconHovered: {
    color: palette.white,
  },
});

export const getAddAllButtonStyle = (_, { palette }) => ({
  ...getKeywordSuggestionFooterButtonStyle(_, { palette }),
  root: {
    height: 32,
    padding: '0px 12px',
    border: '1px solid #D1D1D1',
    borderRadius: 4,
    color: palette.neutralPrimary,
    maxWidth: '100%', // Needed for the button to not overflow its container, truncate text instead
  },
  flexContainer: {
    '& i': {
      color: '#0078D4',
    },
  },
  flexContainerHovered: {
    color: palette.white,
  },
  label: {
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 'unset',
  },
});

export const getExploreKeywordsButtonStyle = (_, { palette }, isSuggestedItemsEmpty) => ({
  ...getKeywordSuggestionFooterButtonStyle(_, { palette }),
  root: {
    height: 32,
    padding: '0px 12px',
    border: '1px solid #D1D1D1',
    borderRadius: 4,
    color: palette.neutralPrimary,
    maxWidth: '100%', // Needed for the button to not overflow its container, truncate text instead
    ...isSuggestedItemsEmpty ? { position: 'absolute', right: 20 } : {},
  },
  flexContainer: {
    '& i': {
      marginBottom: 9,
    },
  },
  label: {
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 'unset',
    marginBottom: 2,
  },
});
